import { z } from "zod";

/**
 * ListItemNodeSchema - Content Schema for List Item Node
 *
 * List item nodes are individual items within a list.
 *
 * Nesting constraints (based on Lexical's isInline check):
 * - ✅ Supports: TextNode, StockNode, TagNode, LinkNode, LinebreakNode (inline nodes only)
 * - ❌ Does NOT support: ParagraphNode, ListNode, HeadingNode, QuoteNode (block nodes)
 * - Note: Can contain nested ListNode for nested lists
 */
export const ListItemNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("listitem"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  checked: z.boolean().optional(), // Checkbox state (only for checkbox lists)
  children: z.array(z.any()), // Array of child nodes (text, stock, tag, link, or nested list)
}).strict();

export type ListItemNode = z.infer<typeof ListItemNodeSchema>;
